/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_SubtitleInputs */

const en_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage your subscription, integrations, and AI usage.`)
};

const de_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalte dein Abonnement, Integrationen und die KI-Nutzung.`)
};

const fr_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gère ton abonnement, tes intégrations et ton utilisation de l'IA.`)
};

const es_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione su suscripción, integraciones y uso de IA.`)
};

const it_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisci la tua sottoscrizione, le integrazioni e l'uso dell'AI.`)
};

const nl_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beheer je abonnement, integraties en AI-gebruik.`)
};

const pl_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj swoim subskrypcją, integracjami i użyciem AI.`)
};

const fi_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallinnoi tilauksesi, integraatioita ja AI-käyttöä.`)
};

const da_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrer dit abonnement, integreringer og AI-brug.`)
};

const sv_settings_subtitle = /** @type {(inputs: Settings_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantera ditt prenumeration, integreringar och AI-användning.`)
};

/**
* | output |
* | --- |
* | "Manage your subscription, integrations, and AI usage." |
*
* @param {Settings_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_subtitle = /** @type {((inputs?: Settings_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_subtitle(inputs)
	if (locale === "fr") return fr_settings_subtitle(inputs)
	if (locale === "es") return es_settings_subtitle(inputs)
	if (locale === "it") return it_settings_subtitle(inputs)
	if (locale === "nl") return nl_settings_subtitle(inputs)
	if (locale === "pl") return pl_settings_subtitle(inputs)
	if (locale === "fi") return fi_settings_subtitle(inputs)
	if (locale === "da") return da_settings_subtitle(inputs)
	if (locale === "sv") return sv_settings_subtitle(inputs)
	return en_settings_subtitle(inputs)
});